var moment = require('moment');
var _ = require('underscore');
var helper = {};

helper.substractOneUnit = function (timestamp, aggregation) {
  if (!_.isNumber(timestamp)) {
    return timestamp;
  }

  var result = moment.unix(timestamp).utc();
  aggregation && aggregation === 'week'
    ? result.subtract(1, 'day')
    : result.subtract(1, aggregation);

  return result.unix();
};

module.exports = helper;



//////////////////
// WEBPACK FOOTER
// ./~/cartodb-deep-insights.js/src/util/timestamp-helper.js
// module id = 665
// module chunks = 2 3